var _rect, _path, _path2, _path3, _path4, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffreshIconSummary3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 18L15.018 31.4151L15 50.4959L39.9579 65L65 50.5128V31.4151L41 18Z",
    fill: "#D1DDFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9919 67L65 52.7434V49L39.9919 63.1659L15 49.033V52.7764L39.9919 67Z",
    fill: "#A8B1CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 17V34.3444L15 49V31.504L41 17Z",
    fill: "#A8B1CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0155 34.3444L65 49V31.5041L41 17",
    fill: "#A8B1CE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 80,
    height: 80,
    rx: 40,
    stroke: "#F2F4FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffreshIconSummary3);
export default __webpack_public_path__ + "static/media/offresh_icon-summary3.da673fd9cb0a3274457c7ca20a728631.svg";
export { ForwardRef as ReactComponent };